import { clearInput } from './clear-input';

export function hideNavbarSearch(form) {
  form.classList.remove('show');
  form.querySelector('input[name="search-form-input"]').blur();
}

export function showNavbarSearch(form) {
  form.classList.add('show');
  form.querySelector('input[name="search-form-input"]').focus();
}

export function handleNavbarSearchSubmit(e, form) {
  e.preventDefault();

  const isVisible = form.classList.contains('show');
  const inputValue = form.querySelector(
    'input[name="search-form-input"]'
  ).value;

  // Hide the search
  if (isVisible && !inputValue) {
    hideNavbarSearch(form);
    return;
  }

  // Show the search
  if (!isVisible) {
    showNavbarSearch(form);
  }

  // Submit action
  if (isVisible && inputValue !== '' && inputValue.length > 0) {
    form.submit();
    clearInput(e);
  }
}

export function onKeyUp(e, form) {
  if (e.key === 'Escape') {
    hideNavbarSearch(form);
  }
}

export function onClickOutside(e, form) {
  if (!form.contains(e.target)) {
    hideNavbarSearch(form);
  }
}

export function initializeNavbarSearch() {
  const mediaQuery = window.matchMedia('(min-width: 1200px)');
  const searchForm = document.querySelector('.navbar-search-form');

  if (mediaQuery.matches && searchForm) {
    const toggleBtn = searchForm.querySelector('.search-toggle');
    toggleBtn.addEventListener('click', (e) =>
      handleNavbarSearchSubmit(e, searchForm)
    );

    // Close search on click outside or escape key
    window.addEventListener('keyup', (e) => onKeyUp(e, searchForm));
    window.addEventListener('mousedown', (e) => onClickOutside(e, searchForm));
    window.addEventListener('touchend', (e) => onClickOutside(e, searchForm));
  }
}
